export default __webpack_public_path__ + "static/media/1.64597ed5.png";